interface CacheEntry<T> {
  data: T;
  timestamp: number;
  expiresAt: number;
}

// In-memory cache storage
const cache: Record<string, CacheEntry<any>> = {};

/**
 * Get data from memory cache
 */
export const getFromCache = <T>(key: string): T | null => {
  const entry = cache[key];
  
  // Return null if not in cache or expired
  if (!entry || Date.now() > entry.expiresAt) {
    if (entry) {
      // Clean up expired entry
      delete cache[key];
    }
    return null;
  }
  
  return entry.data;
};

/**
 * Store data in memory cache
 */
export const setInCache = <T>(key: string, data: T, ttl = 5 * 60 * 1000): void => {
  cache[key] = {
    data,
    timestamp: Date.now(),
    expiresAt: Date.now() + ttl
  };
};

/**
 * Clear a specific item from cache
 */
export const removeFromCache = (key: string): void => {
  delete cache[key];
};

/**
 * Clear all cached data
 */
export const clearCache = (): void => {
  console.log('Clearing all cache data');
  Object.keys(cache).forEach(key => {
    delete cache[key];
  });
};

/**
 * Get cache statistics
 */
export const getCacheStats = (): { size: number, keys: string[] } => {
  return {
    size: Object.keys(cache).length,
    keys: Object.keys(cache)
  };
};
